import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { TLocalesKeys } from '../../../../types';
import { CaroIcon } from '../../../common/components/CaroIcon';
import { useIsAiChatbot } from '../../../common/hooks/useIsAiChatbot';
import { botAvatarDataHooks } from './BotAvatar.dataHooks';
import { BotAvatarAI } from './BotAvatarAI';

export const BotAvatar: FC = () => {
  const { t } = useTranslation();

  const isAiChatbot = useIsAiChatbot();

  if (isAiChatbot) {
    return <BotAvatarAI isLoading={false} text={t<TLocalesKeys>('widget_title_ai_chatbot')} />;
  }

  return (
    <Box dataHook={botAvatarDataHooks.botAvatar()} gap="SP1" verticalAlign="middle">
      <CaroIcon size={24} />
      <Text size="small" secondary>
        {t<TLocalesKeys>('widget_title')}
      </Text>
    </Box>
  );
};
